import { InjectionToken } from '@angular/core';

export interface CrudConfig {
  apiUrl: string;
}

export const CRUD_CONFIG = new InjectionToken<CrudConfig>('CrudConfig');
